import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogProps,
  DialogTitle,
  SubmitButton,
} from '@fortem-monorepo/react-ui'

import { AddBucketForm } from '@/components/forms/AddBucketForm/AddBucketForm'
import { AddBucketFormFields } from '@/components/forms/AddBucketForm/AddBucketFormFields'

export interface AddBucketModalProps extends DialogProps {}

export const AddBucketModal: React.FC<AddBucketModalProps> = ({ ...props }) => {
  return (
    <Dialog {...props}>
      <DialogContent>
        <AddBucketForm defaultValues={{ bucket_type: 'INVESTMENT_TYPE' }}>
          {({ formState: { isValid, isSubmitting } }) => {
            return (
              <>
                <DialogHeader>
                  <DialogTitle>Add a new Bucket</DialogTitle>
                </DialogHeader>
                <div className="my-6">
                  <AddBucketFormFields />
                </div>
                <DialogFooter>
                  <Button
                    type="button"
                    variant={'destructive'}
                    size="sm"
                    onClick={() => props.onOpenChange?.(false)}
                  >
                    Cancel
                  </Button>
                  <SubmitButton
                    disabled={!isValid || isSubmitting}
                    loading={isSubmitting}
                    size="sm"
                  >
                    Submit
                  </SubmitButton>
                </DialogFooter>
              </>
            )
          }}
        </AddBucketForm>
      </DialogContent>
    </Dialog>
  )
}
